export default {
  webmails: {
    list: [],
    total: 0
  },
}
